var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('div',[(_vm.statusInfo.processing)?_c('FAIcon',{attrs:{"icon":"fa fa-spin fa-spinner"}}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.isAdmin ? _vm.statusInfo.descriptionAdmin : _vm.statusInfo.descriptionUser)+"\n")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }